<template>
  <div>
    <b-form @submit="preventDefault">
      <b-form-group
          id="input-group-1"
          label-for="input-1"
          description="Vous pouvez chercher un motif par mot clé."
      >
        <b-form-input
            id="input-1"
            type="text"
            required
            placeholder="Recherche par motif.."
            v-model="motRecherche"
            ref="recherche"
            v-on:keydown.enter.prevent="preventDefault"
            @keyup="toRegex"
        ></b-form-input>
      </b-form-group>
    </b-form>

    <div v-show="showResult">
      <h2>Selectionner le motif</h2>
      <div class="icon-list">
        <div v-for="motif in filteredMotifs" :key="motif.id" class="amsom-button"
             @click="setAllCategorisationAndRedirectToAdress(motif.id)">
          <button class="btn btn-secondary">
            <i :class="fontawesomeico(motif.id)"></i>
          </button>
          <span class="amsom-button-libelle">{{ motif.libelle }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import regexNormalize from "@/js/regex";

export default {
  name: "RechercheMotif",
  data() {
    return {
      motRecherche: "",
      selectedSollicitation: null,
      motifs: this.$store.getters['motifs/iCanWrite'],
      rechercheRegex: null
    }
  },
  methods: {
    fontawesomeico(ID) {
      if (ID === "TECH") return 'fas fa-tools'
      return 'fas fa-cog'
    },
    setAllCategorisationAndRedirectToAdress(motifID) {
      // On recupere les ID de categorisation
      let nature = this.$store.getters['motifs/getMotifById'](motifID)?.nature
      let type = this.$store.getters['natures/getNatureById'](nature)?.type
      let categorie = this.$store.getters['types/getTypeById'](type)?.categorie

      // On fixe la categorisation selectionne dans chacun des store
      this.$store.dispatch('motifs/setSelectedMotif', motifID)
      this.$store.dispatch('natures/setSelectedNature', nature)
      this.$store.dispatch('types/setSelectedType', type)
      this.$store.dispatch('categories/setSelectedCategory', categorie)

      // On redirige vers la selection de l'adresse
      this.$router.push({
        name: 'adresse',
        params: {sollicitation: this.selectedSollicitation}
      })
    },
    toRegex(){
      this.rechercheRegex = regexNormalize(this.motRecherche)
    },
    preventDefault(e) {
      e.preventDefault()
    }

  },
  computed: {
    // motifs() {
    //   // return JSON.parse(this.$store.getters['motifs/'].motifs)
    //   return this.$store.getters['motifs/'].getMyMotif()
    // },
    filteredMotifs() {
      if (this.motifs != null && this.rechercheRegex != null) {
        let r = this.rechercheRegex

        return this.motifs.filter(
            motif =>
                motif.libelle.toLowerCase().replace(/\s/g, "").includes(r)
        )
      }
      else return null
    },
    showResult() {
      if (this.filteredMotifs != null && this.motRecherche.length > 0) return true
      else return false
    }
  },
  mounted() {
    if (typeof this.$route.params.sollicitation !== 'undefined' && this.$route.params.sollicitation !== null) {
      this.selectedSollicitation = this.$route.params.sollicitation
    }
  }
}
</script>

<style scoped>

</style>